import {
  Component, OnDestroy
} from '@angular/core';
import {
  Store
} from '@ngrx/store';
import * as fromRoot from 'src/store/';
import * as fromWorkspace from 'src/store/workspace';
import {
  MsAdalAngular6Service
} from 'microsoft-adal-angular6';
import { Observable, Subscription } from 'rxjs';
import { UserRole, StaffDTO, View } from 'src/store/workspace';

@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.scss']
})
export class WorkspaceComponent implements OnDestroy {
  view$: Observable<View>;
  View = View;
  loading$: Observable<boolean>;
  staff: StaffDTO;
  staffSubs: Subscription;
  constructor(
    private store: Store < fromRoot.AppState > ,
    private adal: MsAdalAngular6Service,
  ) {
    this.store.dispatch(new fromWorkspace.LoadPayPeriods());
    this.store.dispatch(new fromWorkspace.LoadClients());
    this.staffSubs = this.store.select(state => state.workspace.staff).subscribe(staff => {
      if (staff && staff.isCurrentUserAdmin) {
        if (this.staff && staff.staffID === this.staff.staffID) {
          return;
        }
        this.store.dispatch(new fromWorkspace.LoadCategories());
        this.staff = staff;
      }
    });
    this.view$ = this.store.select(state => state.workspace.view);
    this.loading$ = this.store.select(state => state.workspace.loading);
  }

  ngOnDestroy() {
    this.staffSubs.unsubscribe();
  }

  logout = () => {
    this.adal.logout();
  }
}
